import { render } from "./addColumnsPopup.vue?vue&type=template&id=38eed8ad&scoped=true"
import script from "./addColumnsPopup.vue?vue&type=script&lang=js"
export * from "./addColumnsPopup.vue?vue&type=script&lang=js"

import "./addColumnsPopup.vue?vue&type=style&index=0&id=38eed8ad&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eed8ad"]])

export default __exports__